// return the array of the central indexes of an array of length 'arrLength'
// if the length is Odd returns an array of the 4 central indexes
// if the length is Even returns an array of the 5 central indexes
import { isOdd } from '@Utils/miscUtils';

export function getCentralIndexes(arrLength: number): number[] {
  // we always assume that array length is >=4
  const centralIndex = getCentralIndex(arrLength);
  const result = [
    centralIndex - 2,
    centralIndex - 1,
    centralIndex,
    centralIndex + 1,
  ];

  if (isOdd(arrLength)) {
    result.push(centralIndex + 2);
  }

  return result;
}

export function getCentralIndex(arrLength: number): number {
  return Math.floor(arrLength / 2);
}
